'use client';
import { useMemo } from 'react';
import { round, unique } from '@s7/utils';

var dynamicMultipliers = function(width) {
    // Чем больше картинка, тем большее кол-во шагов используем
    if (width < 160) {
        return [
            0.5,
            1,
            2
        ];
    }
    if (width < 750) {
        return [
            0.5,
            1,
            1.5,
            2
        ];
    }
    if (width < 1400) {
        return [
            0.25,
            0.5,
            0.75,
            1,
            1.5,
            2
        ];
    }
    return [
        0.25,
        0.5,
        0.75,
        1,
        1.25,
        1.5,
        1.75,
        2
    ];
};
function useResponsiveImage(options, responsive) {
    var _options_width = options.width, width = _options_width === void 0 ? null : _options_width, _options_height = options.height, height = _options_height === void 0 ? null : _options_height, _options_baseUrl = options.baseUrl, baseUrl = _options_baseUrl === void 0 ? "" : _options_baseUrl, src = options.src, srcPrefix = options.srcPrefix, loader = options.loader;
    return useMemo(function() {
        if (!responsive || !width || !height) {
            var srcUrl = loader ? loader({
                baseUrl: baseUrl,
                srcPrefix: srcPrefix,
                src: src,
                options: {
                    width: width,
                    height: height
                }
            }) : src;
            return {
                src: srcUrl
            };
        }
        var srcSetEntries = dynamicMultipliers(width).map(function(multiple) {
            var computedWidth = round(width * multiple);
            var computedHeight = round(height * multiple);
            /*
                 * Для очень маленьких картинок оптимальной стратегией является
                 * загрузка в оригинальном разрешении.
                 * */ if (multiple < 1 && computedWidth < 50) {
                return null;
            }
            var url = loader ? loader({
                baseUrl: baseUrl,
                src: src,
                srcPrefix: srcPrefix,
                options: {
                    width: computedWidth,
                    height: computedHeight,
                    quality: 90
                }
            }) : src;
            return url + " " + computedWidth + "w";
        }).filter(Boolean);
        return {
            srcSet: unique(srcSetEntries).join(", ")
        };
    }, [
        width,
        height,
        loader,
        baseUrl,
        src,
        srcPrefix,
        responsive
    ]);
}

export { useResponsiveImage };
